// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"27":"964704604c393c04","2194":"e2badde9115fd190","2966":"ac06817b38c65ea5","3153":"e60ae54416c19e6d","4796":"d4f7ca081b72a407","5034":"9d1dcadee69be86b"}[chunkId] + ".css";
};